import React, { useEffect, useMemo, useState } from 'react';
import { clearSystemLog, subscribeSystemLog } from '../services/systemLog';

function formatTime(isoDate) {
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(new Date(isoDate));
  } catch (_error) {
    return '';
  }
}

function getEntryLabel(type) {
  return {
    request: 'Enviando',
    success: 'OK',
    error: 'Erro',
    info: 'Info'
  }[type] || 'Info';
}

export default function SystemLogBar() {
  const [entries, setEntries] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => subscribeSystemLog(setEntries), []);

  const latestEntry = entries[0];
  const errorCount = useMemo(
    () => entries.filter((entry) => entry.type === 'error').length,
    [entries]
  );

  return (
    <footer className={`system-log ${expanded ? 'system-log--expanded' : ''}`} aria-live="polite">
      <div className="system-log__summary">
        <div className="system-log__latest">
          <span className={`system-log__dot system-log__dot--${latestEntry?.type || 'info'}`} />
          <strong>Log do sistema</strong>
          <span>
            {latestEntry
              ? `${formatTime(latestEntry.at)} - ${latestEntry.message}`
              : 'Aguardando atividade da aplicacao.'}
          </span>
        </div>
        <div className="system-log__actions">
          <span>{entries.length} eventos</span>
          {errorCount > 0 && <span className="system-log__error-count">{errorCount} erros</span>}
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => clearSystemLog()}>
            Limpar
          </button>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setExpanded((current) => !current)}>
            {expanded ? 'Recolher' : 'Expandir'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="system-log__list" role="log">
          {!entries.length && <div className="system-log__empty">Nenhum evento registrado nesta sessao.</div>}
          {entries.map((entry) => (
            <article key={entry.id} className={`system-log__entry system-log__entry--${entry.type}`}>
              <div className="system-log__entry-header">
                <span>{formatTime(entry.at)}</span>
                <strong>{getEntryLabel(entry.type)}</strong>
                <span>{entry.message}</span>
              </div>
              {Boolean(Object.keys(entry.details || {}).length) && (
                <dl className="system-log__details">
                  {Object.entries(entry.details).map(([key, value]) => (
                    <React.Fragment key={key}>
                      <dt>{key}</dt>
                      <dd>{value}</dd>
                    </React.Fragment>
                  ))}
                </dl>
              )}
            </article>
          ))}
        </div>
      )}
    </footer>
  );
}
